



<!-- header container -->
<div class="header-mobile-container w-100 d-flex justify-content-between align-items-center">


  <div class="header-mobile-body-left h-100 d-flex">
    <!-- <div class="menu-icon d-flex align-items-center">
      <img
        src="../../../../assets/header-mobile-img/menu.png"
        class="header-icon"
        alt=""
      />
    </div> -->
    <div class="logo d-flex align-items-center">
      <img [src]="logo_img" alt="" routerLink="/mobile/home" />
    </div>
  </div>


  <div class="header-mobile-body-right d-flex">

    <svg class="profile-icon"
    (click)="showSearchBar()"

     xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-search header-icons" viewBox="0 0 16 16">
      <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
    </svg>


    <div class="profile-icon">

      <svg
      (click)="switchToProfile()"
      xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-person  header-icons" viewBox="0 0 16 16">
        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z"/>
      </svg>

    </div>
    <div class="position-relative">
      <div class="align-items-center d-flex">
        <svg
        (click)="display_cart(true);"
        xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-cart2  header-icons" viewBox="0 0 16 16">
          <path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l1.25 5h8.22l1.25-5H3.14zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"/>
        </svg>
      </div>

      <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger badge-cus">
        {{ number_of_cart_items }}
        <span class="visually-hidden">{{"unread messages" }}</span>
      </span>
    </div>

    <div class="divider-style-cus"></div>

  </div>


</div>




<!-- search container -->
<ima-header-mobile-search-view></ima-header-mobile-search-view>




<lib-base-header-componenet/>
